var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "form-fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875@20230203",
    transform: "translate(-434.000000, -123.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-11",
    transform: "translate(434.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "form-fill",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#000000",
    opacity: 0,
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5833333,4.66666668 C22.5498316,4.66666668 23.3333333,5.45016836 23.3333333,6.41666668 L23.3333333,21.5833333 C23.3333333,22.5498316 22.5498316,23.3333333 21.5833333,23.3333333 L6.41666668,23.3333333 C5.45016836,23.3333333 4.66666668,22.5498316 4.66666668,21.5833333 L4.66666668,6.41666668 C4.66666668,5.45016836 5.45016836,4.66666668 6.41666668,4.66666668 L21.5833333,4.66666668 Z M9.33333332,18.9583333 L6.41666668,18.9583333 L6.41666668,21.5833333 L9.33333332,21.5833333 L9.33333332,18.9583333 Z M21.5833333,18.9583333 L11.0833333,18.9583333 L11.0833333,21.5833333 L21.5833333,21.5833333 L21.5833333,18.9583333 Z M9.33333332,14.5833333 L6.41666668,14.5833333 L6.41666668,17.2083333 L9.33333332,17.2083333 L9.33333332,14.5833333 Z M21.5833333,14.5833333 L11.0833333,14.5833333 L11.0833333,17.2083333 L21.5833333,17.2083333 L21.5833333,14.5833333 Z M9.33333332,10.2083333 L6.41666668,10.2083333 L6.41666668,12.8333333 L9.33333332,12.8333333 L9.33333332,10.2083333 L9.33333332,10.2083333 Z M21.5833333,10.2083333 L11.0833333,10.2083333 L11.0833333,12.8333333 L21.5833333,12.8333333 L21.5833333,10.2083333 L21.5833333,10.2083333 Z",
    id: "\\u5F62\\u72B6",
    fill: "currentColor"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormFill);
export default __webpack_public_path__ + "static/media/form-fill.5a6d0b3fa0b0bfe8f98931fdfcfc8254.svg";
export { ForwardRef as ReactComponent };